/**
 * Object tools.
 */
export class ObjTools {
    /**
     * Determines if obj is undefined or null.
     *
     * @param obj object
     * @returns {boolean} truth value
     */
    static isNully(obj) {
        return typeof obj === 'undefined' || obj === null;
    }

    /**
     * Determines if an obj is undefined, null or empty string.
     *
     * @param obj object
     * @returns {boolean} truth value
     */
    static isNullyOrEmpty(obj) {
        return this.isNully(obj) || (typeof obj === 'string' && obj === '')
    }

    /**
     * Checks if value is a float.
     *
     * @param value value
     * @returns {boolean} truth value
     */
    static isFloat(value) {
        if (this.isNully(value))
            return false;

        return !isNaN(parseFloat(value)) && isFinite(value);
    }

    /**
     * Checks if value is a integer.
     *
     * @param value value
     * @returns {boolean} truth value
     */
    static isInt(value) {
        if (this.isNully(value))
            return false;

        return !isNaN(parseInt(value)) && isFinite(value) && value.toString().indexOf('.') === -1;
    }

    /**
     * Add a zero before numbers less than 9 if needed.
     *
     * @param number number
     * @returns {string} string version of the number
     */
    static addZeroForLessThan9AsStr(number) {
        if (number <= 9) {
            return '0' + number;
        } else {
            return '' + number;
        }
    }

    /**
     * Merge 2 objects.
     *
     * @param object1 obj1
     * @param object2 obj2 (can overwrite obj1 if same property name)
     * @returns {{}} new object
     */
    static mergeObjects(object1, object2) {
        let obj = {};

        function merge(obj1, obj2) {
            $.each(obj2, function (key, value) {
                obj1[key] = value;
            });
        }

        if (!this.isNully(object1)) {
            merge(obj, object1);
        }

        if (!this.isNully(object2)) {
            merge(obj, object2);
        }

        return obj;
    };

    /**
     * Generate an array that contains all the values of a string list
     * separated by a given separator. Ex:
     *
     * '1, 5, 7, 23'
     *
     * returns
     *
     * [1,6,7,23]
     *
     * @param stringList string list
     * @param separator separator
     */
    static stringListToArray(stringList, separator){
        let that = this;
        let arr = [];

        if (this.isNully(stringList)){
            return arr;
        }

        if (this.isNully(separator)){
            return [stringList];
        }

        let sepArr = stringList.split(separator);

        if (!this.isNully(sepArr) && sepArr.length > 0){
            sepArr.forEach(function (item, index) {
                if (!that.isNully(item)){
                    item = item.trim();
                }

                if (item !== ''){
                    arr.push(item);
                }
            });
        }

        return arr;
    }

    /**
     * Generate an array that contains all the values of a string list
     * separated by a given separator. Ex:
     *
     * [1,6,7,23]
     *
     * returns
     *
     * '1, 5, 7, 23'
     *
     * @param array array
     * @param separator separator
     */
    static arrayToStringList(array, separator){
        let that = this;
        let strList = '';

        if (this.isNully(array)){
            return strList;
        }

        if (this.isNully(separator)){
            separator = ',';
        }

        const newArray = [];
        array.forEach(function (item, index) {
            if (!that.isNully(item)){
                newArray.push(item);
            }
        });

        strList = newArray.join(separator);

        return strList;
    }

    static b64toBlob(b64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    static stripHtmlFromString(inputString){
        if (ObjTools.isNullyOrEmpty(inputString)){
            return inputString;
        }

        return inputString.replace(/<\/?[^>]+(>|$)/g, "");
    }
}